<template>
  <div>
    <section>
      <div class="wp1200">
        <div class="onBoardRegistration padd">
          <hr class="blue" />
          <h4>Vaš trenutni status</h4>
          <form>
            <ul class="options">
              <li>
                <label class="hoverEffect">
                  <input name="education" type="radio" />
                  <small class="lableTxt">Učenec, dijak, študent</small>
                  <span class="effect"></span>
                </label>
              </li>
              <li>
                <label class="selected hoverEffect">
                  <input name="education" type="radio" checked="checked" />
                  <small class="lableTxt">Zaposlen</small>
                  <span class="effect"></span>
                </label>
              </li>
              <li>
                <label class="hoverEffect">
                  <input name="education" type="radio" />
                  <small class="lableTxt">Samozaposlen</small>
                  <span class="effect"></span>
                </label>
              </li>
              <li>
                <label class="hoverEffect">
                  <input name="education" type="radio" />
                  <small class="lableTxt">Brezposeln</small>
                  <span class="effect"></span>
                </label>
              </li>
              <li>
                <label class="hoverEffect">
                  <input name="education" type="radio" />
                  <small class="lableTxt">Upokojenec</small>
                  <span class="effect"></span>
                </label>
              </li>
              <li>
                <label class="hoverEffect">
                  <input name="education" type="radio" />
                  <small class="lableTxt">Drugo</small>
                  <span class="effect"></span>
                </label>
              </li>
            </ul>
            <div class="next flex">
              <a
                class="txt"
                href="https://studiolev.si/warp-panel/on_board_address.html"
              >Prejšnji korak</a>
              <a
                class="join smallFont hoverEffect"
                href="https://studiolev.si/warp-panel/on_board_household.html"
              >
                <label>Naslednji korak</label>
                <span class="effect"></span>
                <img src="@/assets/images/nextArrowAnimation.svg" />
              </a>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      notCompleted: true,
    };
  },
  components: {},
  mounted() {},
  methods: {},
};
</script>
<style>
</style>